module.exports = __webpack_public_path__ + "static/sport/title.cd52a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/title.png
// module id = RF4A
// module chunks = 0